export const digitsRegx = /^\d+$/
export const digitsRegxError = 'regx.digitsRegxError'
export const alphanumericRegex = /^[-_ a-zA-Z0-9]+$/
export const alphanumericRegexError = 'regx.alphanumericRegexError'
export const alphaRegex = /^[a-zA-Z]*$/
export const alphaRegexError = 'regx.alphaRegexError'
export const specialRegex = /[^a-zA-Z0-9\s]/
export const specialRegexError = 'regx.specialRegexError'
export const specialCharacterRegex = !/^[a-zA-Z0-9]$/
